"use strict";

var cov_2oc9p8tn3g = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\book\\BookHeaders.js";
  var hash = "6558f7df121cbdb2d8a63bb44e3f228ccb59cc9f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\book\\BookHeaders.js",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 29
        }
      },
      "2": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 19,
          column: 95
        }
      },
      "3": {
        start: {
          line: 20,
          column: 19
        },
        end: {
          line: 20,
          column: 74
        }
      },
      "4": {
        start: {
          line: 20,
          column: 44
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "5": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 27,
          column: 4
        }
      },
      "6": {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 36,
          column: 2
        }
      },
      "7": {
        start: {
          line: 38,
          column: 18
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "8": {
        start: {
          line: 38,
          column: 39
        },
        end: {
          line: 43,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 27
          },
          end: {
            line: 12,
            column: 28
          }
        },
        loc: {
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 34
          },
          end: {
            line: 20,
            column: 35
          }
        },
        loc: {
          start: {
            line: 20,
            column: 44
          },
          end: {
            line: 20,
            column: 62
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 29
          },
          end: {
            line: 38,
            column: 30
          }
        },
        loc: {
          start: {
            line: 38,
            column: 39
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 38
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 46
          },
          end: {
            line: 23,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 46
          },
          end: {
            line: 23,
            column: 55
          }
        }, {
          start: {
            line: 23,
            column: 59
          },
          end: {
            line: 23,
            column: 65
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "6558f7df121cbdb2d8a63bb44e3f228ccb59cc9f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BookHeaders = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _ = require("..");

cov_2oc9p8tn3g.s[0]++;

var BookHeaders = function BookHeaders(_ref) {
  var headers = _ref.headers,
      showUnsupported = _ref.showUnsupported,
      direction = _ref.direction;
  cov_2oc9p8tn3g.f[0]++;
  var classes = (cov_2oc9p8tn3g.s[1]++, useStyles());
  var bookHeaders = (cov_2oc9p8tn3g.s[2]++, _react.default.createElement(_.VerseObjects, {
    verseObjects: headers,
    showUnsupported: showUnsupported
  }));
  var bookName = (cov_2oc9p8tn3g.s[3]++, headers.filter(function (header) {
    cov_2oc9p8tn3g.f[1]++;
    cov_2oc9p8tn3g.s[4]++;
    return header.tag === 'h';
  })[0].content);
  cov_2oc9p8tn3g.s[5]++;
  return _react.default.createElement("div", {
    className: classes.bookHeaders,
    dir: (cov_2oc9p8tn3g.b[0][0]++, direction) || (cov_2oc9p8tn3g.b[0][1]++, 'auto')
  }, _react.default.createElement(_core.Typography, {
    variant: "h2",
    className: classes.bookName
  }, bookName), bookHeaders);
};

exports.BookHeaders = BookHeaders;
cov_2oc9p8tn3g.s[6]++;
BookHeaders.propTypes = {
  headers: _propTypes.default.array.isRequired,

  /** render unsupported usfm markers */
  showUnsupported: _propTypes.default.bool,

  /** override text direction detection */
  direction: _propTypes.default.string
};
var useStyles = (cov_2oc9p8tn3g.s[7]++, (0, _styles.makeStyles)(function (theme) {
  cov_2oc9p8tn3g.f[2]++;
  cov_2oc9p8tn3g.s[8]++;
  return {
    bookHeaders: {},
    bookName: {}
  };
}));
var _default = BookHeaders;
exports.default = _default;